import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=6a3a8409&scoped=true&"
import script from "./Administrative.vue?vue&type=script&lang=js&"
export * from "./Administrative.vue?vue&type=script&lang=js&"
import style0 from "./Administrative.vue?vue&type=style&index=0&id=6a3a8409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a8409",
  null
  
)

export default component.exports